import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core, Decorative } from "@faire/design-tokens";
import { AspectRatioPicture } from "@faire/retailer-visitor-shared/components/Image/AspectRatioPicture";
import { setTimeoutIfPossible } from "@faire/retailer-visitor-shared/lib/async-functions/setTimeoutIfPossible";
import { circularMod } from "@faire/retailer-visitor-shared/lib/math";
import { FadingImage } from "@faire/retailer-visitor-shared/views/careers/__internal__/common/common";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { optimizeImageUrl } from "@faire/web--source/common/transform-images";
import { Column, Flex } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { observer } from "mobx-react";
import React, { useEffect, useCallback, useState, useRef } from "react";
import styled from "styled-components";
var ODD_IMAGES = [
    "https://cdn.faire.com/fastly/ee7b91e11f0b074e6da724534ba6e99c73f8d62197df2282030eef638a1f6bde.png",
    "https://cdn.faire.com/fastly/1e25f24c136ff6a47fb85e81f55c2b0797ab99d317078f7099b6899ed62db902.png",
    "https://cdn.faire.com/fastly/f690e7c5ceceec03d4043c91d951406e9956981ecf04b526e1ac1f7e38ff34a8.png"
];
var EVEN_IMAGES = [
    "https://cdn.faire.com/fastly/56a06b75c4f0293d2d5cfd7f7cbf804027d4da489fe70051ee324a396dfa5661.png",
    "https://cdn.faire.com/fastly/53b6ec5cff2d17054d086844a4fbacad0b00a4b0a1f31a2138da0f4e406f2867.png",
    "https://cdn.faire.com/fastly/34e638eea0fa694a1a3959eed5abda4bba4d4a034c14f4763e635fbdaf20c6fb.png"
];
var IMAGES_LENGTH = Math.min(ODD_IMAGES.length, EVEN_IMAGES.length);
var OurBenefitsImagesSectionBase = function() {
    var _useState = _sliced_to_array(useState(0), 2), currentIndex = _useState[0], setCurrentIndex = _useState[1];
    var resumeScrollHandler = useCallback(function() {
        setTimeoutIfPossible(function() {
            setCurrentIndex(function(currentIndex) {
                return circularMod(currentIndex + 1, IMAGES_LENGTH);
            });
            resumeScrollHandler();
        }, 4000);
    }, []);
    var didMount = useRef(false);
    useEffect(function() {
        if (didMount.current) {
            return;
        }
        didMount.current = true;
        resumeScrollHandler();
    }, [
        resumeScrollHandler
    ]);
    return /*#__PURE__*/ _jsx(Wrapper, {
        children: /*#__PURE__*/ _jsxs(ResponsiveContainer, {
            children: [
                /*#__PURE__*/ _jsx(Images, {
                    images: ODD_IMAGES,
                    currentIndex: currentIndex
                }),
                /*#__PURE__*/ _jsx(Spacer, {
                    size: "1x"
                }),
                /*#__PURE__*/ _jsx(Images, {
                    images: EVEN_IMAGES,
                    currentIndex: currentIndex
                })
            ]
        })
    });
};
export var OurBenefitsImagesSection = observer(OurBenefitsImagesSectionBase);
var Images = function(param) {
    var images = param.images, currentIndex = param.currentIndex;
    var isSSR = useIsSSR();
    return /*#__PURE__*/ _jsx(ImageContainer, {
        children: /*#__PURE__*/ _jsx(AspectRatioPicture, {
            $ratio: 1.5,
            $width: "100%",
            $hideBorder: true,
            children: images.map(function(imageUrl, index) {
                return /*#__PURE__*/ _jsx(FadingImage, {
                    src: optimizeImageUrl({
                        url: imageUrl
                    }, isSSR, {
                        width: 636
                    }),
                    $isActive: index === currentIndex
                }, index);
            })
        })
    });
};
var Wrapper = styled(Column).attrs({
    align: "center"
}).withConfig({
    componentId: "sc-8659c91b-0"
})([
    "",
    "{background:linear-gradient( to bottom,",
    " 0%,",
    " 50%,",
    " 50%,",
    " 100% );}"
], responsiveMediaQueries.tabletAndAbove, Decorative.tint.neutral, Decorative.tint.neutral, Core.surface.inverse, Core.surface.inverse);
var ResponsiveContainer = styled(Flex).attrs({
    direction: {
        mobileAndAbove: "column",
        tabletAndAbove: "row"
    }
}).withConfig({
    componentId: "sc-8659c91b-1"
})([
    "width:100%;max-width:1280px;"
]);
var ImageContainer = styled.div.withConfig({
    componentId: "sc-8659c91b-2"
})([
    "flex:1;"
]);
